"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInterceptor = void 0;
const axios_1 = __importDefault(require("axios"));
function defaultConfigWithAccess(config, accessToken) {
    return Object.assign(Object.assign({}, config), { headers: Object.assign(Object.assign({}, config.headers), { Authorization: `Bearer ${accessToken}` }) });
}
function defaultIsFailedAuthorization(response) {
    return (response.status === 401 &&
        response.config.headers !== undefined &&
        response.config.headers.Authorization !== undefined &&
        typeof response.config.headers.Authorization === "string" &&
        response.config.headers.Authorization.indexOf("Bearer") === 0);
}
function defaultGetAccessFromRefreshResponse(response) {
    return response.data.access_token;
}
function createRequestInterceptor(options) {
    let refreshLock = null;
    return (cfg) => {
        return Promise.resolve()
            .then(options.getAuthData)
            .then((authData) => {
            if (!authData.accessToken) {
                return cfg;
            }
            if (!refreshLock &&
                authData.expireDate &&
                authData.expireDate <= new Date() &&
                authData.refreshToken) {
                if (options.verbose) {
                    console.info("[AUTH REFRESH] Attempting auth refresh");
                }
                refreshLock = options.axiosInstance
                    .request(options.getRefreshConfig(authData.refreshToken))
                    .then((response) => {
                    if (options.verbose) {
                        console.info("[AUTH REFRESH] Refresh successful");
                    }
                    options.onSignIn(response);
                    return options.getAccessFromRefreshResponse(response);
                })
                    .catch((err) => {
                    if (options.verbose) {
                        console.info("[AUTH REFRESH] Refresh failed");
                        console.warn(err);
                    }
                    err._isFailedRefresh = true;
                    options.onSignOut(err);
                    throw err;
                });
            }
            if (refreshLock) {
                if (options.verbose) {
                    console.info("[AUTH REFRESH] Waiting on refresh before attempting request");
                }
                const queuedRequest = refreshLock.then((newAccessToken) => {
                    if (!newAccessToken) {
                        console.warn(`No access token found in refresh response body. This probably means that you need to provide a custom getAccessFromRefreshResponse implementation.`);
                    }
                    refreshLock = null;
                    return options.configWithAccess(cfg, newAccessToken);
                });
                queuedRequest.catch((err) => {
                    if (err._isFailedRefresh) {
                        refreshLock = null;
                    }
                    else if (options.verbose) {
                        console.warn(err);
                    }
                });
                return queuedRequest;
            }
            return options.configWithAccess(cfg, authData.accessToken);
        });
    };
}
function createFailureInterceptor(options) {
    return (err) => {
        if (err.response && options.isFailedAuthorization(err.response)) {
            options.onSignOut(err);
        }
        return Promise.reject(err);
    };
}
function createInterceptor(options) {
    const finalOptions = Object.assign({ axiosInstance: axios_1.default.create(), configWithAccess: defaultConfigWithAccess, getAccessFromRefreshResponse: defaultGetAccessFromRefreshResponse, isFailedAuthorization: defaultIsFailedAuthorization, verbose: false }, options);
    return {
        request: createRequestInterceptor(finalOptions),
        failure: createFailureInterceptor(finalOptions),
    };
}
exports.createInterceptor = createInterceptor;
